<template>
    <div style="width: 99%; display: block; padding: 5px; margin-left: auto; margin-right: auto;">

        <b-modal id="modal-so-items" @hide="fetch_orders" scrollable title="CUSTOMER BACKORDER ITEMS" size="xl" hide-footer style="min-height: 700px;">
            <CustomerBackOrderItems v-on:done-items-so="close_so_items" style="min-height: 700px;" :viewdata="{customer_backorder_po_id: customer_backorder_po_id, customer_backorder_po_vendor_id: customer_backorder_po_vendor_id}" />
        </b-modal>

        <!-- Product Detail Modal - ADD THIS -->
        <ProductDetailModal 
            ref="productDetailModal"
            :productSku="currentDetailProductSku"
            :orderData="currentDetailOrderData"
            v-if="showProductDetail"
            @view-product="viewProductDetail"
            @open-product-detail="openProductDetail"
            @hidden="handleProductModalHidden"
        />

        <div style="display: block; margin-top: 10px;">
            <div
              v-if="isMobile"
              class="d-flex justify-content-between align-items-center mb-2 px-1"
            >
              <b-button
                size="sm"
                variant="outline-primary"
                @click="filtersVisible = !filtersVisible"
              >
                <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
              </b-button>
            </div>

            <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
              <b-alert variant="secondary" show>
                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>ETA</div>
                  <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                  ></date-picker>
                </div>

                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>STATUS</div>
                  <b-form-select :options="statuses" v-model="status"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>VENDOR</div>
                  <b-form-select :options="packet.vendors" v-model="vendor"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>RECEIVING LOC</div>
                  <b-form-select :options="filter_receiving_locations" v-model="receiving_loc_filter"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>SHIPPING LOC</div>
                  <b-form-select :options="filter_locations" v-model="ship_to_filter"></b-form-select>
                </div>

                <div style="width: 200px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>ITEM SEARCH</div>
                  <b-form-input
                    v-model="itemSearch"
                    placeholder="Search products..."
                    style="width: 280px; font-size: 14px;"
                    debounce="300"
                  ></b-form-input>
                </div>
              </b-alert>
            </b-collapse>

            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="true">
                    </loading>
                </div>

                <div v-else>
                    <div v-if="items.length == 0">
                        <b-alert show variant="warning"> NO CUSTOMER BACKORDERS PO </b-alert>
                    </div>
                    <div v-else>
                        <div class="diver">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="srr" style="width: 150px; background-color: lightyellow;" >PO #</th>
                                        <th class="srr" style="width: 150px; background-color: lightyellow;">VENDOR</th>
                                        <th class="srr" style="width: 120px; background-color: lightyellow;">STATUS</th>
                                        <th class="srr" style="width: 130px; background-color: lightyellow">SCHEDULE DATE</th>
                                        <th  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)" class="srr" style="width: 130px; background-color: lightyellow;">REQUEST DATE</th>
                                         <th class="srr" style="width: 120px; background-color: lightyellow">SCH DATE</th>
                                        <th class="srr" style="width: 120px; background-color: lightblue">RCV DATES</th>
                                        <th class="srr" style="width: 80px; background-color: lightblue">ITEMS ORDRD</th>
                                        <th class="srr" style="width: 80px; background-color: lightblue">ITEMS RCVD</th>
                                        <th class="srr" style="width: 80px; background-color: lightblue">ITEMS RMNG</th>
                                           <th class="srr" style="width: 80px; background-color: lightblue">CUBES</th>
                                        <th  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)"class="srr" style="width: 150px; background-color: lightblue">BILL TO</th>
                                        <th  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)" class="srr" style="width: 150px; background-color: lightblue">SHIP TO</th>
                                        <th  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)"class="srr" style="width: 150px; background-color: lightblue">RCVNG LOCs</th>
                                        
                                        <th class="srr" style=" width: 60px;">
                                            <b-button
                                                size="sm"
                                                @click="isDetailsExpanded = !isDetailsExpanded"
                                                variant="outline-primary"
                                                :disabled="packet.userDetails.userrole  === 'warehouseuser'">
                                                {{ isDetailsExpanded ? 'HIDE' : 'SHOW' }}
                                            </b-button>
                                        </th>
                                         <th v-if="isDetailsExpanded" class="srr" style="width: 150px; background-color: lightgreen;">SOLD DATE</th>
                                         <th v-if="isDetailsExpanded" class="srr" style="width: 200px; background-color: lightgreen;">ORDERING LOC</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 200px; background-color: lightgreen;">INVOICE NO.</th>
                                         <th v-if="isDetailsExpanded"class="srr" style="width: 180px; background-color: lightgreen;">CUSTOMER NAME</th>
                                        <th v-if="isDetailsExpanded && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)"class="srr" style="width: 150px; background-color: lightgreen;">SKU.</th>
                                        <th v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)"class="srr"  style="width: 180px; background-color: lightgreen;">ITEMS DESCRIPTION</th>
                                        <th v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)"class="srr"  style="width: 120px; background-color: lightgreen;">SOLD PRICE</th>
                                        <th v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)"class="srr"  style="width: 120px; background-color: lightgreen;">LANDED</th>
                                        <th style = "width: 220px;" class="srr">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item,idx in filteredItems" v-bind:key="idx">
                                        <td class="srrv">
                                                {{item.po_number}}
                                        </td>
                                        <td class="srrv">
                                        {{vendorsDict[item.vendor_id]}}
                                        </td>

                                           <td class="srrv">
                                                  <b-form-select
                                                      :options="getStatusOptions(item)"
                                                      v-model="item.status"
                                                      size="sm"
                                                      :disabled="isItemDisabled2(item)"
                                                  ></b-form-select>
                                              </td>
                                       <td class="srrv">
                                          <date-picker
                                              v-model="item.schedule_date"
                                              format="MM-DD-YYYY"
                                              :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                              valueType="format"
                                              style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 110px; font-size: 11px;"
                                              @change="handleScheduleDateChange(item)"
                                          ></date-picker>
                                      </td>
                                        <td  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)" class="srrv">
                                          <date-picker
                                              v-model="item.eta"
                                              format="MM-DD-YYYY"
                                              :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                              valueType="format"
                                              style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 110px; font-size: 11px;"
                                              @change="handleETADateChange(item)"
                                          ></date-picker>
                                      </td>
                                          <td class="srrv" style="background: lightyellow;">
                                            <div v-if="item.showSchDates">
                                                <button v-if="Array.isArray(item.schedule_dates) && item.schedule_dates.length > 0" @click="item.showSchDates = false">HIDE</button>
                                                <div v-for="rd,rdidx in item.schedule_dates" v-bind:key="rdidx" style="display: block; margin: 5px;" v-if="rd">
                                                    <div class="box" variant="primary" style="font-size: 11px;">{{rd}}</div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button
                                                    v-if="Array.isArray(item.schedule_dates) && item.schedule_dates[0] !== null"
                                                    @click="item.showSchDates = true"
                                                    :disabled="Array.isArray(item.schedule_dates) && item.schedule_dates.length === 0"
                                                >
                                                  SHOW {{ (item.schedule_dates || []).length }} DATES
                                                </button>
                                            </div>
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            <div v-if="item.showRcvDates">
                                                <button v-if="Array.isArray(item.receiving_dates) && item.receiving_dates.length > 0" @click="item.showRcvDates = false">HIDE</button>
                                                <div v-for="rd,rdidx in item.receiving_dates" v-bind:key="rdidx" style="display: block; margin: 5px;" v-if="rd">
                                                    <div class="box" variant="primary" style="font-size: 11px;">{{rd}}</div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button
                                                    v-if="Array.isArray(item.receiving_dates) && item.receiving_dates[0] !== null"
                                                    @click="item.showRcvDates = true"
                                                    :disabled="Array.isArray(item.receiving_dates) && item.receiving_dates.length === 0"
                                                >
                                                  SHOW {{ (item.receiving_dates || []).length }} DATES
                                                </button>
                                            </div>
                                        </td>

                                        <td class="srrv" style="background: lightblue;">
                                            {{item.quantity_ordered}}
                                        </td>

                                        <td class="srrv" style="background: lightblue;">
                                            {{item.received_items}}
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            {{item.remaining_items}}
                                        </td>
                                         <td class="srrv" style="background: lightblue;">
                                            {{item.cubes}}
                                        </td>
                                       <td  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)"class="srrv" style="background: lightblue;">
                                            <template v-if="packet.userDetails.userrole === 'admin'">
                                                <b-form-select
                                                    size="sm"
                                                    :options="bill_to_location"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    v-model="item.bill_to"
                                                    @change="handleLocationChange(item, 'bill_to')"
                                                ></b-form-select>
                                            </template>
                                            <template v-else>
                                                <b-form-select
                                                    size="sm"
                                                    :options="getBillToOptionsForItem(item)"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    v-model="item.bill_to"
                                                    @change="handleLocationChange(item, 'bill_to')"
                                                ></b-form-select>
                                            </template>
                                        </td>

                                        <td  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)"class="srrv" style="background: lightblue;">
                                            <template v-if="packet.userDetails.userrole === 'admin'">
                                                <b-form-select
                                                    size="sm"
                                                    :options="Ship_to_location"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    v-model="item.ship_to"
                                                    @change="handleLocationChange(item, 'ship_to')"
                                                ></b-form-select>
                                            </template>
                                            <template v-else>
                                                <b-form-select
                                                    size="sm"
                                                    :options="getShipToOptionsForItem(item)"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    v-model="item.ship_to"
                                                    @change="handleLocationChange(item, 'ship_to')"
                                                ></b-form-select>
                                            </template>
                                        </td>

                                        <td  v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)"class="srrv" style="background: lightblue;">
                                            <template v-if="packet.userDetails.userrole === 'admin'">
                                                <b-form-select
                                                    size="sm"
                                                    :options="filteredReceivingLocations(item)"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    v-model="item.receiving_location_id"
                                                ></b-form-select>
                                            </template>
                                            <template v-else>
                                                <b-form-select
                                                    size="sm"
                                                    :options="getReceivingOptionsForItem(item)"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    v-model="item.receiving_location_id"
                                                ></b-form-select>
                                            </template>
                                        </td>
                                    <td class="srrv"></td>
                                        <td v-if="isDetailsExpanded" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 13px;">
                                                {{formatDate( p.sold_at )}}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 11px;">
                                               {{packet.locsubsdict[item.ordering_location]}}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>
                                            <td v-if="isDetailsExpanded"class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 13px;">
                                                {{ p.invoice_id }}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>
                                         <td v-if="isDetailsExpanded" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 13px;">
                                                {{ item.customer_name }}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>
                                          <td v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 13px;">
                                                {{ p.product_sku }}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>

                                        <td v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 11px;">
                                                {{ p.product_name }}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>
                                        <td v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 14px;">
                                                {{ parseFloat(p.selling_price).toFixed(2) }}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>
                                        <td v-if="isDetailsExpanded  && ['admin', 'officemanager', 'warehouseuser',  'warehousemanager'].includes(packet.userDetails.userrole)" class="srrv" style=" background-color: #DEEED8;">
                                          <div v-if="item.showDetails">
                                            <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                            <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                              <div class="box" variant="success" style="font-size: 14px;">
                                                {{ p.landed_cost }}
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <button @click="item.showDetails = true" :disabled="Array.isArray(item.product_skus) && item.product_skus.length === 0">
                                              SHOW {{ (item.product_skus || []).length }} ITEMS
                                            </button>
                                          </div>
                                        </td>

                                        <td class="srrv">
                                             <div style="display: inline-block;">
                                                <b-button size="sm" variant="outline-success"
                                                  @click="view_item(item)" v-b-tooltip.hover title="VIEW ITEMS">
                                                <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                                </div>

                                            <!-- ADD PRODUCT DETAIL BUTTON HERE -->
                                            <div style="display: inline-block;">
                                                <b-button 
                                                    size="sm" 
                                                    variant="outline-info" 
                                                    @click="showProductDetailModal(item)"
                                                    v-b-tooltip.hover 
                                                    title="VIEW PRODUCT DETAILS"
                                                    :disabled="!item || !item.product_skus || item.product_skus.length === 0"
                                                >
                                                    <b-icon icon="grid-3x3-gap-fill" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>

                                                <div style="display: inline-block;">
                                                <b-button size="sm"
                                                v-if="packet.userDetails.userrole == 'admin'"
                                                variant="outline-primary" @click="update_customer_backorder_po(item)" v-b-tooltip.hover title="SAVE">
                                                <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                            </b-button>
                                                </div>
                                                <div style="display: inline-block;">
                                                <b-button
                                                size="sm"
                                                variant="outline-danger"
                                                v-if="packet.userDetails.userrole == 'admin'"
                                                @click="delete_order(item)"
                                                v-b-tooltip.hover
                                                :title="item.status === 8 ? 'DELETE ORDER' : 'Only archived orders can be deleted'"
                                                :disabled="item.status !== 8"
                                            >
                                                <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css'
    import CustomerBackOrderItems from "@/components/VendorOrders/CustomerBackOrderItems"
    import ProductDetailModal from "@/components/VendorOrders/ProductDetailModal" // ADD THIS IMPORT
    import { BIconFunnelFill } from 'bootstrap-vue'

    export default {
        name: "ListCustomerBackOrders",
        props: [],
        components: {
            flatPickr, 
            Loading,
            DatePicker,
            VueSimpleSuggest, 
            CustomerBackOrderItems,
            ProductDetailModal // ADD THIS
        },
        data: function(){
            return {
                packet: {},
                items: [],
                ship_to: [],
                bill_to: [],
                isDetailsExpanded: false,
                receiving_dropdown_locations: [],
                ship_to_filter: null,
                items_being_loaded: null,
                statuses: [
                    {value: "open", text: "OPEN"},
                    {value: 1, text: "NEW"},
                    {value: 2, text: "ORDERED"},
                    {value: 3, text: "SCHEDULED"},
                    {value: 4, text: "IN-TRANSIT"},
                    {value: 5, text: "PARTIAL"},
                    {value: 6, text: "RECEIVED"},
                    {value: 7, text: "COMPLETED"},
                    {value: 8, text: "ARCHIVED"},
                ],
                customer_backorder_po_id: null,
                customer_backorder_po_vendor_id: null,
                create_new: false,
                schedule_date:null,
                eta:null,
                // Filters
                status: "open",
                vendor: null,
                date_range: [],
                ship_to_filter: null,
                receiving_loc_filter: null,
                itemSearch: '',
                // Location options
                locations: [],
                receiving_locations: [],
                filter_locations: [],
                filter_receiving_locations: [],
                filtersVisible: false,
                isMobile: false,
                // ADD THESE FOR PRODUCT DETAIL MODAL
                currentDetailProductSku: null,
                currentDetailOrderData: null,
                showProductDetail: false,
            };
        },
        mounted() {
          this.handleResize()
          window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            filteredShipToLocations: function() {
                return function() {
                    return this.Ship_to_location;
                };
            },
            filteredReceivingLocations: function() {
                return function(item) {
                    const shipToLocation = item.ship_to;

                    if (!shipToLocation) {
                        return this.receiving_dropdown_locations;
                    }

                    const shipToText = this.getLocationText(shipToLocation);

                    if (shipToText === 'MECCA WHOLESALE') {
                        return this.receiving_dropdown_locations.filter(loc => {
                            const locText = loc.text.toUpperCase().trim();
                            return locText === '9TH ST' ||
                                   locText === '101 WH' ||
                                   locText === 'FOLCROFT' ||
                                   locText.includes('9TH ST') ||
                                   locText.includes('101 WH') ||
                                   locText.includes('FOLCROFT');
                        });
                    } else {
                        return this.receiving_dropdown_locations.filter(loc =>
                            loc.value == shipToLocation || loc.text === shipToText
                        );
                    }
                };
            },
            bill_to_location() {
                const excludedBillTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', '9TH ST ', '101 WH', 'FOLCROFT'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let billToLocations = allLocations
                    .filter(loc => !excludedBillTo.includes(loc.text))
                    .map(this.replaceMecca);

                const meccaWholesaleOption = { value: 47, text: 'MECCA WHOLESALE', isMecca: true };
                
                billToLocations = billToLocations.filter(loc => loc.text !== 'MECCA WHOLESALE');
                billToLocations.unshift(meccaWholesaleOption);

                return billToLocations;
            },
            Ship_to_location() {
                const excludedShipTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let shipToLocations = allLocations
                    .filter(loc => !excludedShipTo.includes(loc.text))
                    .map(this.replaceMecca);

                const warehouseLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                
                shipToLocations = shipToLocations.filter(loc =>
                    !warehouseLocations.some(wh => loc.text.includes(wh))
                );

                const meccaOption = { value: 47, text: 'MECCA WHOLESALE', isMecca: true };
                shipToLocations.unshift(meccaOption);

                return shipToLocations;
            },
            vendorsDict() {
                const dict = {};
                this.packet.vendors.forEach(vendor => {
                    if (vendor.value) {
                        dict[vendor.value] = vendor.text;
                    }
                });
                return dict;
            },
            filteredItems: function() {
                let that = this;
                return that.items.filter(d => {
                    return (
                        ((that.vendor) ? d.vendor_id == that.vendor : true) &&
                        (that.status !== null && that.status !== undefined
                            ? (that.status == "open"
                                ? [1,2,3,4,5].includes(d.status)
                                : d.status == that.status
                              )
                            : true
                        ) &&
                        (this.date_range.length === 2 && !this.date_range.includes(null)
                            ? moment(d.eta).isSameOrAfter(moment(this.date_range[0]), 'day') &&
                              moment(d.eta).isSameOrBefore(moment(this.date_range[1]), 'day')
                            : true
                        ) &&
                        ((that.receiving_loc_filter) ? d.receiving_location_id == that.receiving_loc_filter : true) &&
                        ((that.ship_to_filter) ? d.ship_to == that.ship_to_filter : true) &&
                        ((that.itemSearch) ?
                            d.product_skus.some(sku =>
                                sku.product_name.toLowerCase().includes(that.itemSearch.toLowerCase())
                            ) : true
                        )
                    );
                });
            }
        },
        methods: {
            // ===== ADD THESE METHODS FOR PRODUCT DETAIL MODAL =====
            showProductDetailModal(item) {
                console.log('Opening product detail modal with item:', item);
                
                if (!item || !item.product_skus || item.product_skus.length === 0) {
                    this.$bvToast.toast("No products found in this customer backorder", { 
                        title: "Info", 
                        variant: "info" 
                    });
                    return;
                }
                
                // Reset data first to ensure clean state
                this.currentDetailProductSku = null;
                this.currentDetailOrderData = null;
                this.showProductDetail = false;
                
                this.$nextTick(() => {
                    this.currentDetailOrderData = item;
                    this.currentDetailProductSku = item.product_skus[0].product_sku || item.product_skus[0].sku;
                    this.showProductDetail = true;
                    
                    console.log('Set product detail data:', {
                        sku: this.currentDetailProductSku,
                        orderData: this.currentDetailOrderData
                    });
                    
                    this.$nextTick(() => {
                        this.$bvModal.show('modal-product-detail');
                    });
                });
            },

            handleProductModalHidden() {
                console.log('Product modal hidden, resetting data');
                setTimeout(() => {
                    this.showProductDetail = false;
                    this.currentDetailProductSku = null;
                    this.currentDetailOrderData = null;
                    console.log('Product detail data reset');
                }, 300);
            },

            viewProductDetail(sku) {
                this.$bvModal.hide('modal-product-detail');
                this.currentDetailProductSku = sku;
                this.currentDetailOrderData = null;
                setTimeout(() => {
                    this.$bvModal.show('modal-product-detail');
                }, 300);
            },

            openProductDetail(sku) {
                this.$bvToast.toast(
                    `Opening full details for SKU: ${sku}`,
                    { title: "Info", variant: "info" }
                );
            },
            // ===== END PRODUCT DETAIL MODAL METHODS =====

            debugLocations() {
                console.log('=== DEBUG LOCATIONS ===');
                console.log('Bill To Locations:', this.bill_to_location);
                console.log('Ship To Locations:', this.Ship_to_location);
                
                const firstItem = this.items && this.items[0];
                console.log('Current item bill_to value:', firstItem ? firstItem.bill_to : 'No items');
                console.log('Current item ship_to value:', firstItem ? firstItem.ship_to : 'No items');
                
                const billToHasMecca = this.bill_to_location.some(loc => loc.value === 0);
                const shipToHasMecca = this.Ship_to_location.some(loc => loc.value === 0);
                console.log('Bill To has MECCA WHOLESALE (0):', billToHasMecca);
                console.log('Ship To has MECCA WHOLESALE (0):', shipToHasMecca);
            },
            
            getBillToOptionsForItem(item) {
                const excludedBillTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', '9TH ST ', '101 WH', 'FOLCROFT'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let billToLocations = allLocations
                    .filter(loc => !excludedBillTo.includes(loc.text))
                    .map(this.replaceMecca);

                const meccaWholesaleOption = { value: 47, text: 'MECCA WHOLESALE', isMecca: true };
                
                billToLocations = billToLocations.filter(loc => loc.text !== 'MECCA WHOLESALE');
                billToLocations.unshift(meccaWholesaleOption);

                const userLocationId = this.packet.userDetails.properties.location_id;
                const currentValue = item.bill_to;
                
                if (this.packet.userDetails.userrole !== 'admin') {
                    const validValues = new Set([userLocationId, currentValue]);
                    billToLocations = billToLocations.filter(d => validValues.has(d.value));
                }

                return billToLocations;
            },
            
            getShipToOptionsForItem(item) {
                const excludedShipTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let shipToLocations = allLocations
                    .filter(loc => !excludedShipTo.includes(loc.text))
                    .map(this.replaceMecca);

                const warehouseLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                
                shipToLocations = shipToLocations.filter(loc =>
                    !warehouseLocations.some(wh => loc.text.includes(wh))
                );

                const meccaOption = { value: 47, text: 'MECCA WHOLESALE', isMecca: true };
                shipToLocations.unshift(meccaOption);

                const userLocationId = this.packet.userDetails.properties.location_id;
                const currentValue = item.ship_to;
                
                if (this.packet.userDetails.userrole !== 'admin') {
                    const validValues = new Set([userLocationId, currentValue]);
                    shipToLocations = shipToLocations.filter(d => validValues.has(d.value));
                }

                return shipToLocations;
            },
            
            getReceivingOptionsForItem(item) {
                const shipToLocation = item.ship_to;

                if (!shipToLocation) {
                    const userLocationId = this.packet.userDetails.properties.location_id;
                    const currentValue = item.receiving_location_id;
                    
                    if (this.packet.userDetails.userrole !== 'admin') {
                        const validValues = new Set([userLocationId, currentValue]);
                        return this.receiving_dropdown_locations.filter(d => validValues.has(d.value));
                    }
                    return this.receiving_dropdown_locations;
                }

                const shipToText = this.getLocationText(shipToLocation);
                let filteredLocations = [];

                if (shipToText === 'MECCA WHOLESALE') {
                    filteredLocations = this.receiving_dropdown_locations.filter(loc => {
                        const locText = loc.text.toUpperCase().trim();
                        return locText === '9TH ST' ||
                               locText === '101 WH' ||
                               locText === 'FOLCROFT' ||
                               locText.includes('9TH ST') ||
                               locText.includes('101 WH') ||
                               locText.includes('FOLCROFT');
                    });
                } else {
                    filteredLocations = this.receiving_dropdown_locations.filter(loc =>
                        loc.value == shipToLocation || loc.text === shipToText
                    );
                }

                const currentValue = item.receiving_location_id;
                if (this.packet.userDetails.userrole !== 'admin' && currentValue) {
                    const currentValueExists = filteredLocations.some(loc => loc.value == currentValue);
                    if (!currentValueExists) {
                        const currentLocation = this.receiving_dropdown_locations.find(loc => loc.value == currentValue);
                        if (currentLocation) {
                            filteredLocations.push(currentLocation);
                        }
                    }
                }

                return filteredLocations;
            },
            
            getLocationText: function(locationValue) {
                if (locationValue === 0 || locationValue === '0') {
                    return 'MECCA WHOLESALE';
                }

                const normalizeText = (text) => text.toUpperCase().trim();

                const billToLoc = this.bill_to_location.find(loc => loc.value == locationValue);
                if (billToLoc) return normalizeText(billToLoc.text);

                const shipToLoc = this.Ship_to_location.find(loc => loc.value == locationValue);
                if (shipToLoc) return normalizeText(shipToLoc.text);

                const allLoc = this.packet.locations.find(loc => loc.value == locationValue);
                return allLoc ? normalizeText(allLoc.text) : '';
            },

            replaceMecca: function(location) {
                if (location.text === '9th ST, 101 WH, FOLCROFT') {
                    return { ...location, text: 'MECCA WHOLESALE' };
                }
                return location;
            },
            handleShipToChange: function(item, field) {
                const shipToLocation = item.ship_to;

                item.receiving_location_id = null;

                if (shipToLocation && shipToLocation !== '0') {
                    item.receiving_location_id = shipToLocation;
                }
            },
            handleBillToChange: function(item, field) {
                console.log(`${field} changed for item ${item.id}:`, item[field]);
            },
            isWarehouseUser() {
                return this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser';
            },
            handleLocationChange: function(item, field) {
                if (field === 'ship_to') {
                    this.handleShipToChange(item, field);
                } else if (field === 'bill_to') {
                    this.handleBillToChange(item, field);
                }
            },
            setupLocations: function() {
                const allLocations = this.packet.locations.filter(d => 
                    d && d.text && d.text != 'All' && d.value != null
                );
                
                const userLocationId = this.packet.userDetails.properties.location_id;
                const isAdmin = this.packet.userDetails.userrole === 'admin';

                const excludedLocationTexts = ['ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];

                console.log('=== SETUP LOCATIONS DEBUG ===');
                console.log('All locations from packet:', allLocations);

                this.locations = allLocations
                    .filter(location => location.text && !excludedLocationTexts.includes(location.text))
                    .map(this.replaceMecca);

                this.receiving_dropdown_locations = allLocations
                    .filter(loc => {
                        if (!loc.text) return false;
                        const locText = loc.text.toUpperCase();
                        return !excludedLocationTexts.some(excluded =>
                            locText.includes(excluded.toUpperCase())
                        );
                    })
                    .map(this.replaceMecca);

                console.log('=== RECEIVING LOCATIONS ===');
                this.receiving_dropdown_locations.forEach(loc => {
                    console.log(`- ${loc.text} (ID: ${loc.value})`);
                });

                const allentownInReceiving = this.receiving_dropdown_locations.find(loc => 
                    loc.value.toString() === '25'
                );
                console.log('Allentown in receiving locations:', allentownInReceiving);

                if (!allentownInReceiving) {
                    console.log('Allentown missing from receiving locations, adding manually...');
                    const allentownFromOriginal = allLocations.find(loc => 
                        loc.value.toString() === '25'
                    );
                    if (allentownFromOriginal) {
                        this.receiving_dropdown_locations.push(this.replaceMecca(allentownFromOriginal));
                        console.log('Manually added Allentown to receiving locations');
                    }
                }

                this.filter_locations = [
                    { value: null, text: 'ALL' },
                    ...this.locations
                ];

                this.filter_receiving_locations = [
                    { value: null, text: 'ALL' },
                    ...this.receiving_dropdown_locations
                ];

                console.log('=== FINAL RECEIVING LOCATIONS ===');
                this.receiving_dropdown_locations.forEach(loc => {
                    console.log(`- ${loc.text} (ID: ${loc.value})`);
                });
            },
            isItemDisabled(item) {
                const completedStatuses = [6, 7, 8];

                if (this.packet.userDetails.userrole === 'warehouseuser') {
                    return true;
                }

                if (completedStatuses.includes(item.status)) {
                    return true;
                }

                return false;
            },

            isItemDisabled2(item) {
                const completedStatuses = [7, 8];

                if (this.packet.userDetails.userrole !== 'admin') {
                    return true;
                }

                if (completedStatuses.includes(item.status)) {
                    return true;
                }

                return false;
            },

            getStatusOptions: function(item) {
                const currentStatus = item.status;
                const noItemsReceived = item.received_items === 0;
                const hasPONumber = item.po_number && item.po_number.trim() !== '';

                const STATUS = {
                    NEW: 1,
                    ORDERED: 2,
                    SCHEDULED: 3,
                    IN_TRANSIT: 4,
                    PARTIAL: 5,
                    RECEIVED: 6,
                    COMPLETED: 7,
                    ARCHIVED: 8
                };

                let options = this.statuses.map(status => {
                    let disabled = false;

                    if (hasPONumber && currentStatus !== STATUS.NEW && status.value !== STATUS.NEW) {
                        disabled = true;
                    }

                    if (status.value === STATUS.ARCHIVED) {
                        disabled = !noItemsReceived;
                        return {
                            ...status,
                            disabled: disabled
                        };
                    }

                    if ([STATUS.PARTIAL, STATUS.COMPLETED, STATUS.ARCHIVED].includes(currentStatus)) {
                        disabled = true;
                    }
                    else if (currentStatus === STATUS.NEW) {
                         disabled = ![STATUS.NEW, STATUS.ORDERED, STATUS.SCHEDULED].includes(status.value);
                    }
                    else if (currentStatus === STATUS.ORDERED) {
                        disabled = ![STATUS.ORDERED, STATUS.SCHEDULED, STATUS.IN_TRANSIT].includes(status.value);
                    }
                    else if (currentStatus === STATUS.SCHEDULED) {
                        disabled = ![STATUS.SCHEDULED, STATUS.IN_TRANSIT].includes(status.value);
                    }
                    else if (currentStatus === STATUS.IN_TRANSIT) {
                        disabled = ![STATUS.SCHEDULED, STATUS.IN_TRANSIT].includes(status.value);
                    }
                    else if (currentStatus === STATUS.RECEIVED) {
                        disabled = ![STATUS.COMPLETED].includes(status.value);
                    }
                    else if (currentStatus === STATUS.PARTIAL) {
                        disabled = ![STATUS.RECEIVED, STATUS.COMPLETED, STATUS.ARCHIVED].includes(status.value);
                    }

                    return {
                        ...status,
                        disabled: disabled
                    };
                });

                return options;
            },

            handleStatusChange(item) {
                console.log('Status changed for item:', item);
            },

            handleScheduleDateChange: function(item) {
                console.log('Schedule date changed for item:', item);

                if (item.schedule_date && [1, 2].includes(item.status)) {
                    item.status = 3;
                    this.$bvToast.toast(
                        "Status automatically set to SCHEDULED",
                        {title: "Status Updated", autoHideDelay: 1500, variant:"info"}
                    );
                }
            },
            handleETADateChange(item) {
                console.log('ETA date changed for item:', item);
            },

            getStatusState(item) {
                return null;
            },

            delete_order: function(item){
                if (!item.id){
                    this.$vex.dialog.alert(
                        {message: "PLEASE SAVE THE ORDER FIRST BEFORE DELETING IT."}
                    );
                    return
                }
                let data = {id: item.id};
                let that = this;
                let path = "/api/customer_backorder/delete_customer_backorder_po/"
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "ERROR", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "DELETED",
                            {title: "SUCCESS", autoHideDelay: 1500, variant:"success"}
                        );
                        that.items=that.items.filter(function(d){return d.id != item.id});
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in deleting. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },

            formatDate(dateStr) {
                if (!dateStr) return "";

                let dateObj;
                if (dateStr.includes('GMT')) {
                    dateObj = new Date(dateStr);
                } else {
                    dateObj = new Date(dateStr);
                }

                const day = String(dateObj.getDate()).padStart(2, "0");
                const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                const year = dateObj.getFullYear();
                return `${day}-${month}-${year}`;
            },
            getEarliestSoldAt(item) {
                if (!item.product_skus || !Array.isArray(item.product_skus)) {
                    return '';
                }

                const dateStrings = item.product_skus
                    .filter(sku => sku.sold_at && sku.sold_at.trim() !== '')
                    .map(sku => {
                        return sku.sold_at.split(' ')[0];
                    });

                if (dateStrings.length === 0) {
                    return '';
                }

                const dateObjects = dateStrings.map(dateStr => {
                    const [month, day, year] = dateStr.split('-');
                    return new Date(year, month - 1, day);
                });

                const earliestDate = new Date(Math.min(...dateObjects));

                return moment(earliestDate).format('MM-DD-YYYY');
            },
            validate: function(item) {
                let errors = [];

                if (!item.receiving_location_id) {
                    errors.push({message: "PLEASE INDICATE A RCVNG LOCATION."})
                    return errors;
                }

                const shipToText = this.getLocationText(item.ship_to);
                const receivingText = this.getLocationText(item.receiving_location_id);

                console.log('Validation - Ship To:', shipToText, 'Receiving:', receivingText);

                if (shipToText === 'MECCA WHOLESALE') {
                    const isWarehouseLocation =
                        receivingText.includes('9TH ST') ||
                        receivingText.includes('101 WH') ||
                        receivingText.includes('FOLCROFT');

                    if (!isWarehouseLocation) {
                        errors.push({ message: "For Mecca Wholesale shipping, receiving location must be 9th ST, 101 WH, or FOLCROFT." });
                    }
                } else {
                    if (shipToText !== receivingText) {
                        errors.push({ message: `Receiving location (${receivingText}) must match shipping location (${shipToText}).` });
                    }
                }

                return errors;
            },

            update_customer_backorder_po: function(item) {
                let that = this;
                console.log('=== SAVE DEBUG ===');
                console.log('Item being saved:', item);
                console.log('Receiving location ID:', item.receiving_location_id);
                console.log('Ship to:', item.ship_to);
                console.log('Bill to:', item.bill_to);

                if (item.status === 3 && !item.schedule_date) {
                    this.$vex.dialog.alert(
                        {message: "Schedule date is required when status is SCHEDULED"}
                    );
                    return;
                }

                let errors = this.validate(item);
                if (errors.length > 0) {
                    this.$vex.dialog.alert(
                        {message: errors[0].message}
                    );
                    return;
                }

                const payload = {
                    id: item.id,
                    data: {
                        status: item.status,
                        receiving_location: item.receiving_location_id,
                        bill_to: item.bill_to,
                        shipping_location: item.ship_to,
                        schedule_date: item.schedule_date,
                        eta: item.eta,
                    },
                    items: item.product_skus.map(sku => ({
                        product_sku: sku.product_sku,
                        quantity_received: sku.quantity_received,
                        locsub: sku.locsub,
                        receiving_date: sku.receiving_date,
                        schedule_date: sku.schedule_date,
                        status: sku.status
                    }))
                };

                let path = "/api/customer_backorder/update_customer_backorder_po/";
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "SAVED",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                };

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred in saving. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                };
                Requestor.postSyncP(path, payload, this, s, f);
            },
            fetch_orders: function() {
                let userRole = this.packet.userDetails.userrole;

                let data = {
                    status: this.status,
                    location_id: this.packet.userDetails.properties.location_id,
                    userRole: userRole
                };

                let that = this;
                let path = "/api/customer_backorder/get_customer_backorder_pos/"

                let s = function(response) {
                    if (response.data.result) {
                        let res = response.data.result;
                        console.log('Raw API response:', res);

                        that.items = Array.isArray(res) ? res.map(item => {
                            console.log('Item from backend:', item.id, 'Status:', item.status);

                            return {
                                ...item,
                                status: item.status,
                                schedule_date: item.schedule_date ? moment(item.schedule_date).format('MM-DD-YYYY') : null,
                                eta: item.eta ? moment(item.eta).format('MM-DD-YYYY') : null,
                                showDetails: false,
                                showCategories: false,
                                showRcvDates: false,
                                showSchDates: false,
                                ship_to: item.ship_to !== null ? Number(item.ship_to) : null,
                                bill_to: item.bill_to !== null ? Number(item.bill_to) : null,
                            }
                        }) : [];

                        that.$nextTick(() => {
                            that.debugLocations();
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }

                this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            view_item(item) {
                this.customer_backorder_po_id = item.id;
                this.customer_backorder_po_vendor_id = item.vendor_id;
                this.$bvModal.show("modal-so-items");
            },
            close_so_items: function() {
                this.$bvModal.hide("modal-so-items");
                this.fetch_orders()
            },
            formatDate(date) {
                if (!date) return '';
                if (typeof date === 'string' && date.match(/^\d{2}-\d{2}-\d{4}$/)) {
                    return date;
                }
                return moment(date).format('MM-DD-YYYY');
            },
            getStatusText(statusCode) {
                const statusMap = {
                    1: "NEW",
                    2: "ORDERED",
                    3: "SCHEDULED",
                    4: "IN-TRANSIT",
                    5: "PARTIAL",
                    6: "RECEIVED",
                    7: "COMPLETED",
                    8: "ARCHIVED"
                };
                return statusMap[statusCode] || statusCode;
            }
        },

        created() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.vendors.splice(0, 0, {value: null, text: "ALL"});
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.setupLocations();
            this.fetch_orders();
        }
    }
</script>

<style scoped>
    .diver {
      overflow:auto;
      width:100%;
      height:600px;
      position: relative;
    }
    td,
    th {
      border: 1px solid;
      width: 300px;
    }
    th {background-color:white;}

    table {
      table-layout: fixed;
      width:100%;
      border-collapse: separate; 
      border-spacing: 0;
    }
    td:nth-child(-n+2), 
    th:nth-child(-n+2) {
        position: sticky;
        left: 0;
        z-index: 1;
        background-color: white;
    }
    td:nth-child(1), th:nth-child(1) {
        left: 0;
    }

    td:nth-child(2), th:nth-child(2) {
        left: 150px;
    }

    td:last-child, th:last-child {
      position:sticky;
      right:0;
      z-index:1;
      background-color:white;
      width: 150px;
    }
    thead tr th {
      position:sticky;
      top:0;
       z-index: 5;
      background-color: white;
    }

    thead tr th:nth-child(-n+2) {
        z-index: 7;
    }

    thead tr th:last-child {
        z-index: 7;
    }
    tbody tr td:nth-child(-n+2) {
        z-index: 2;
        background-color: white;
    }

    tbody tr td:last-child {
        z-index: 2;
        background-color: white;
    }

    tbody tr td:nth-child(-n+2):hover,
    tbody tr td:last-child:hover {
        background-color: white;
    }

    .diver table {
        border-collapse: separate;
        border-spacing: 0;
    }
    .srr {
        font-size: 12px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    .box {
        padding: 3px;
        text-align: center;
        margin: 5px;
        background: #c8e6c9;
        color: black;
        border: 1px solid black;
    }

    @media (max-width: 768px) {
        td:nth-child(-n+2),
        th:nth-child(-n+2),
        td:last-child,
        th:last-child,
        thead tr th {
            position: static !important;
            left: auto !important;
            right: auto !important;
            top: auto !important;
            z-index: auto !important;
        }

        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/ListCustomerBackOrders.vue